import React from 'react';

import DoneIcon from '@material-ui/icons/Done';

const confirmedStyle = {
    color : "green"
};

export default function StatusButton(props)
{
  const {
    confirmed,
    ...rest
  } = props;

  return {
      color : "inherit",
      style : confirmed ? confirmedStyle : null,
      label : confirmed ? props.name + "済み" : "未" + props.name,
      "aria-label" : "契約書の内容を" + props.name,
      icon : <DoneIcon />,
      ...rest
  }
}